module.exports = __webpack_public_path__ + "img/ic_edit.6a6d8b67.svg";